import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useClientDetail, useClientSessionHistory } from './clientDetailApi';
import { LoadingState } from '../../components/common/LoadingState';
import { ApiErrorFallback } from '../../components/common/ApiErrorFallback';
import { ClientSessionHistoryItem } from './ClientSessionHistoryItem';
import { Card, CardHeader, CardTitle, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { ExerciseFrequencyChart } from './ExerciseFrequencyChart';

export function ClientDetailPage() {
  const { clientId } = useParams<{ clientId: string }>();
  const { data: client, isLoading: isLoadingClient, error: clientError, refetch: refetchClient } = useClientDetail(clientId || '');
  const { data: history, isLoading: isLoadingHistory, error: historyError, refetch: refetchHistory } = useClientSessionHistory(clientId || '');

  if (isLoadingClient) {
    return <LoadingState message="Loading client details..." />;
  }

  if (clientError) {
    return <ApiErrorFallback error={clientError} onRetry={refetchClient} />;
  }

  if (!client) {
    return <div>Client not found.</div>;
  }

  return (
    <div className="space-y-8">
      <div>
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-3xl font-bold">{client.firstName} {client.lastName}</h1>
          <Link to="/studio/planning">
            <Button>Plan Next Session</Button>
          </Link>
        </div>
        <p className="text-muted-foreground text-lg">{client.email}</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2">
          <Card>
            <CardHeader>
              <CardTitle>Recent Sessions</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              {isLoadingHistory && <LoadingState message="Loading history..." />}
              {historyError && <ApiErrorFallback error={historyError} onRetry={refetchHistory} />}
              {history && history.sessions.map((session: any) => (
                <ClientSessionHistoryItem key={session.id} session={session} />
              ))}
              {history && history.sessions.length === 0 && (
                <p className="text-muted-foreground">No session history found for this client.</p>
              )}
            </CardContent>
          </Card>
        </div>

        <div>
          <Card>
            <CardHeader>
              <CardTitle>Most Frequent Exercises</CardTitle>
            </CardHeader>
            <CardContent>
              <ExerciseFrequencyChart clientId={clientId || ''} />
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}